import { AdvertisementProvider } from '@context/Advertisement';
import { useLocation } from 'react-router-dom';
import FullBannerView from '@pages/Advertisement/FullBannerView';

interface AdvertiseProps {
  state?: {
    image: string;
  };
}

const Advertisement = () => {
  const { state } = useLocation() as AdvertiseProps;

  return (
    <AdvertisementProvider image={state?.image || ''}>
      <FullBannerView />
    </AdvertisementProvider>
  );
};

export default Advertisement;
